export default __webpack_public_path__ + "static/media/studio2020_1.512704da.jpeg";